import React from 'react';
import i18next from 'i18next';
import { Icon } from 'semantic-ui-react';
import { nth, user } from '../../../common/utils';

// https://github.com/react-tools/react-table#columns
export const getColumns = (onSelect) => {
  return [
    nth,
    {
      Header: i18next.t('my:workshops.tableHeaders.event'),
      accessor: 'event.title',
      maxWidth: 200
    },
    {
      Header: i18next.t('my:workshops.tableHeaders.competition'),
      accessor: 'competition.i18n_title',
      maxWidth: 200,
      Cell: ({original: { competition: c}}) => { 
        return JSON.parse(c.i18n_title)[i18next.language];
      }
    },
    {
      Header: () => <Icon name='calendar'/>,
      accessor: 'competition.date',
      maxWidth: 100
    },
    {
      Header: i18next.t('my:workshops.tableHeaders.email'),
      accessor: 'email',
      maxWidth: 200,
      Cell: ({original}) => original.userData.email
    },
    user,
    {
      Header: 'Participant',
      accessor: 'family_name',
      maxWidth: 180,
      Cell: ({ original: { userData: u } }) =>  u.family_name + ', ' + u.given_name
    }
  ];
};

export const getNoDataText = () => {
  return i18next.t('my:workshops.no_data');
};

export const DEFAULTSORTED = [
  { id: 'event.title', desc: false }
];

export const DEFAULTPAGESIZE = 20;



// WEBPACK FOOTER //
// ./src/private/user/components/Workshops/table.conf.js